import { navDirections } from './navDirections'

export const bottomNav = [
    {
        dest: navDirections.HOME,
        text: 'Home',
        icon: 'home'
    },
    {
        dest: navDirections.ONLINE_CLASS,
        text: 'Online Class',
        icon: 'class'
    },
    {
        dest: navDirections.EXAMS,
        text: 'Online Exam',
        icon: 'exam'
    }
]
